import { app, translate } from "../app"
import { languages } from "../locale";
import { Container } from "./container"
import { ImageWithFallback } from "./image";
import { useAnimateOnScroll } from "./useAnimateOnScroll";
import { SplitText } from "./splittext";

export function BlockAbout(props: { block: BlockAbout }) {
  const { block } = props
  useAnimateOnScroll();
  const isRTL = languages[app.locale]?.rtl;
  const locale = app.locale;
  const isEnglish = locale === 'en-US';

  function wrapWithDiv(htmlContent: string) {
      // Remove all <strong> tags with any attributes
      let withoutStrong = htmlContent.replace(/<strong\b[^>]*>|<\/strong>/gi, "");

      // Remove all newline characters
      let withoutNewlines = withoutStrong.replace(/\n/g, "");

      // Regular expression to match each <h2></h2> and <p></p> pair
      const pattern = /(<h2>[\s\S]*?<\/h2>\s*<p>[\s\S]*?<\/p>)/g;

      // Wrap each match in <div> tags
      const wrappedContent = withoutNewlines.replace(pattern, "<div>$1</div>");

      return wrappedContent;
  }

  return <Container block={block}>
    <div id="about-section" className={`pb-8 flex flex-col lg:flex-row gap-4 lg:gap-16 items-stretch ${isRTL ? 'lg:flex-row-reverse' : ''}`}>
      <h1 className={`flex lg:hidden fade-up-1 text-3xl lg:text-4xl !font-normal mb-0 leading-snug`} data-animation="animate__fadeInUp">
        <SplitText text={translate(block.title)} />
      </h1>
      <div className="lg:flex-[0.5] xl:flex-[0.4] flex justify-start rounded-[10px] fade-up-0" data-animation="animate__fadeInUp" >
        <ImageWithFallback filename={block.image} alt={translate(block.title)} className="w-full h-auto lg:h-full rounded-xl about-image my-6 lg:my-0" />
      </div>
      <div className={`lg:flex-[0.5] xl:flex-[0.6] about-content ${isRTL ? 'text-right' : ''}`} style={{ direction: isRTL ? "rtl" : "ltr" }}>
        <h1 className={`hidden lg:flex fade-up-1 text-3xl lg:text-4xl mt-0 mb-10 leading-snug`} data-animation="animate__fadeInUp">
          <SplitText text={translate(block.title)} />
        </h1>
        <div className={`fade-up-2 text-base leading-snug grid grid-cols-1 gap-y-6 about-paragraph`} dangerouslySetInnerHTML={{ __html: isEnglish ? translate(block.subtitle) : wrapWithDiv(translate(block.subtitle)) }} data-animation="animate__fadeInUp"></div>
      </div>
    </div>
  </Container>

}
